import { message } from 'antd'
import axios from 'axios'

let Local_SET_URL = "";

// Local_SET_URL = "http://localhost:4301/fesource";
Local_SET_URL = "https://feapi.mehedigoni.com/fesource";
 

let AX_POST = async (url, body) => {
    try {
        let data = await (await axios.post(url, body,{timeout: 800000})).data
        return data
    } catch (error) {
        console.log("Catch")
        message.destroy()
        message.warn("Problem Found, Try again")
        return []
    }
}


let AX_GET = async (url) => {
    let data = await (await axios.get(url)).data
    return data
}


let AX_GET_File = async (url) => {
    let data = await (await axios.get(url)).data
    return data
}


export  {
    AX_POST,
    AX_GET,
    AX_GET_File,
    Local_SET_URL,
}